import React from 'react';

export interface IHelpItem {
  name: string,
  description: string,
}

const HelpItem = (props: { data: IHelpItem }) => {
  const { data } = props;

  return (
    <li className="js-item item ">
      <div className="item__desc">
        <h2 className="heading heading--2">
          {data.name}
          {' '}
        </h2>
        <p dangerouslySetInnerHTML={{ __html: data.description }} />
      </div>
    </li>
  );
};

export default HelpItem;
